export default __webpack_public_path__ + "static/media/SMG_logo.b7209bdb.png";